import { OPTIONS, TTS_OPTIONS } from '../constants';
import { FormValues } from '../types';

export const getCheckboxLabels = (options: FormValues['options'], isRaskTtsUsed = false) => {
  const selectedLabelIndices: string[] = [];
  const modalOptions = isRaskTtsUsed ? TTS_OPTIONS : OPTIONS;

  options.forEach((value, idx) => {
    if (value) {
      selectedLabelIndices.push(modalOptions[idx].label);
    }
  });
  return selectedLabelIndices;
};
